import { Button } from '@mantine/core';
import { FaPaypal } from 'react-icons/fa';

export function PayPalButton({ onClick }: { onClick: () => void }) {
  return (
    <Button
      onClick={onClick}
      leftIcon={<FaPaypal size={20} />}
      style={{
        backgroundColor: '#003087',
        color: '#fff',
        fontWeight: 'bold',
        borderRadius: '20px',
        padding: '10px 20px',
        fontSize: '16px',
        transition: 'transform 0.2s ease',
      }}
      onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
      onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
    >
      Link PayPal Account
    </Button>
  );
}
